export default {"src":"/_next/static/media/0x0d4a11d5eeaac28ec3f61d100daf4d40471f1852.2e1b6b93.svg","height":129,"width":129,"blurWidth":0,"blurHeight":0};